var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c(
          "div",
          {
            staticClass: "page-header-top-container",
            staticStyle: { width: "100% !important" }
          },
          [
            _c("h1", { staticClass: "page-title" }, [
              _vm._v(" " + _vm._s(_vm.page_header) + " ")
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary waves-effect pull-right",
                attrs: { type: "submit" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.returnOnListing()
                  }
                }
              },
              [_vm._v("Back")]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", { staticClass: "forms-container" }, [
            _c("div", { staticClass: "row no-margin" }, [
              _c("div", { staticClass: "col-6 forms-block" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "col-9 paddingleft0" }, [
                  _c("span", { staticClass: "form-control" }, [
                    _vm._v(_vm._s(_vm.name))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 forms-block" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "col-9 paddingleft0" }, [
                  _c("span", { staticClass: "form-control" }, [
                    _vm._v(_vm._s(_vm.email))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 forms-block" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "col-9 paddingleft0" }, [
                  _c("span", { staticClass: "form-control" }, [
                    _vm._v(_vm._s(_vm.primaryEmail))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 forms-block" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "col-9 paddingleft0" }, [
                  _c("span", { staticClass: "form-control" }, [
                    _vm._v(_vm._s(_vm.contact))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 forms-block" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("div", { staticClass: "col-9 paddingleft0" }, [
                  _c("span", { staticClass: "form-control" }, [
                    _vm._v(_vm._s(_vm.secondaryEmail))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 forms-block" }, [
                _vm._m(5),
                _vm._v(" "),
                _c("div", { staticClass: "col-9 paddingleft0" }, [
                  _c("span", { staticClass: "form-control" }, [
                    _vm._v(_vm._s(_vm.secondaryContact))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 forms-block" }, [
                _vm._m(6),
                _vm._v(" "),
                _c("div", { staticClass: "col-9 paddingleft0" }, [
                  _c("span", { staticClass: "form-control" }, [
                    _vm._v(_vm._s(_vm.thirdEmail))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 forms-block" }, [
                _vm._m(7),
                _vm._v(" "),
                _c("div", { staticClass: "col-9 paddingleft0" }, [
                  _c("span", { staticClass: "form-control" }, [
                    _vm._v(_vm._s(_vm.thirdContact))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 forms-block" }, [
                _vm._m(8),
                _vm._v(" "),
                _c("div", { staticClass: "col-9 paddingleft0" }, [
                  _c("span", { staticClass: "form-control" }, [
                    _vm._v(_vm._s(_vm.addressLine1))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 forms-block" }, [
                _vm._m(9),
                _vm._v(" "),
                _c("div", { staticClass: "col-9 paddingleft0" }, [
                  _c("span", { staticClass: "form-control" }, [
                    _vm._v(_vm._s(_vm.addressLine2))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 forms-block" }, [
                _vm._m(10),
                _vm._v(" "),
                _c("div", { staticClass: "col-9 paddingleft0" }, [
                  _c("span", { staticClass: "form-control" }, [
                    _vm._v(_vm._s(_vm.locationId.name))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 forms-block" }, [
                _vm._m(11),
                _vm._v(" "),
                _c("div", { staticClass: "col-9 paddingleft0" }, [
                  _c("span", { staticClass: "form-control" }, [
                    _vm._v(_vm._s(_vm.zipCode))
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" }),
            _vm._v(" "),
            _c("div", { staticClass: "row clearfix" }),
            _vm._v(" "),
            _c("div", { staticClass: "button-demo" })
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Name :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Email :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Primary Email :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Contact :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Secondary Email :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Secondary Contact :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Third Email :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Third Contact :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Address Line 1 :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Address Line 2 :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Location :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Zip Code :")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ff6926c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ff6926c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customer/CustomerProfile.vue
// module id = null
// module chunks = 